import React from 'react';

import { chartOfAccountsSelectors } from 'app-components/flux/chart-of-accounts';

import Box from '@mui/material/Box';

import MuiTagsField from 'components/QuickenControls/TagsField/TagsField';
import QAmountField from 'components/QAmountField';

import { investmentTransactionEditFormHooks } from 'components/Forms/InvestmentTransactionEditForm/investmentTransactionEditFormHooks';
import type { TagValue } from './types';
import { numberFromInput, tagToId, TypedPayeeAutocomplete } from './utils';

export function CashFlowFields(): React.JSX.Element {
  const payee = investmentTransactionEditFormHooks.useField('payee');
  const tags = investmentTransactionEditFormHooks.useField('tags');
  const tagObjects = investmentTransactionEditFormHooks.useSelector(({ state }) => state.tags);
  const amount = investmentTransactionEditFormHooks.useField('amount');
  const isIncome = investmentTransactionEditFormHooks.useSelector(({ state, store }) =>
    chartOfAccountsSelectors.isIncome(store, state.coa),
  );

  return (
    <>
      <Box display='flex' gap={2}>
        <TypedPayeeAutocomplete
          inputValue={payee.value}
          onInputChange={(_event: React.SyntheticEvent, value: string) => payee.onValueChange(value)}
          textFieldProps={{
            error: payee.error,
            helperText: payee.helperText,
            style: { width: 240 },
            autoFocus: true,
          }}
          selectOnFocus
          openOnFocus={false}
        />
        <MuiTagsField
          id='tags'
          value={tagObjects}
          onChange={(_event: React.SyntheticEvent, tagArray: TagValue[]) => tags.onValueChange(tagArray.map(tagToId))}
        />
      </Box>
      <QAmountField
        id='amount'
        editable
        label='Total amount'
        sx={{ minWidth: 110 }}
        expectedSign={isIncome ? 'positive' : 'negative'}
        value={amount.value ?? undefined}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          const value = numberFromInput(event.target.value);
          if (!Number.isNaN(value)) {
            amount.onValueChange(value);
          }
        }}
        error={amount.error}
        helperText={amount.helperText}
      />
    </>
  );
}
